import { render, staticRenderFns } from "./WombatHeader.vue?vue&type=template&id=d84f6656&scoped=true"
import script from "./WombatHeader.vue?vue&type=script&lang=js"
export * from "./WombatHeader.vue?vue&type=script&lang=js"
import style0 from "./WombatHeader.vue?vue&type=style&index=0&id=d84f6656&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84f6656",
  null
  
)

export default component.exports